<template>
  <div>
    <div class="research-block">
      <ResearchShooting />
    </div>
    <div v-if="!loading" class="container-block_gallery">
      <ShootingsGallery />
      <LoadMore v-if="shootings.length > 0" />
    </div>
    <div v-else class="loader-block">
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ShootingsGallery from '@/components/shootings/ShootingsGallery.vue'
import LoadMore from '@/components/shootings/LoadMore.vue'
import Loader from '@/components/Loader.vue'
import ResearchShooting from '@/components/shootings/ResearchShooting.vue'

export default {
  name: 'Shootings',
  components: {
    ShootingsGallery,
    Loader,
    LoadMore,
    ResearchShooting
  },
  computed: {
    ...mapGetters('usersConfig', {
      typesForUser: 'typesForUser'
    }),
    ...mapGetters(['userId']),
    ...mapState({
      loading: state => state.loading,
      shootings: state => state.shootings,
      researchShooting: state => state.researchShooting.current,
      userOptions: state => state.userOptions
    }),
    accessTradein() {
      const useVideoAccess = this.userOptions && this.userOptions.find(el => el.name === 'use2spect')

      return (useVideoAccess && useVideoAccess.value) || false
    }
  },

  created() {
    const types = this.setInitialTypes()
    this.$store.commit('RESEARCH_TYPES', types)

    const payload = {
      userId: this.userId,
      startDate: this.researchShooting.startDate,
      endDate: this.researchShooting.endDate,
      registration: this.researchShooting.registration,
      types: this.typesForUser
    }

    this.$store.dispatch('getShootings', payload)
  },

  methods: {
    setInitialTypes() {
      return this.typesForUser
    }
  }
}
</script>

<style lang="less" scoped>
.container-block_gallery {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.loader-block {
  width: 100%;
  height: 100%;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.research-block {
  display: flex;
  justify-content: center;
}
</style>
